import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import {NavigationEnd, Router, NavigationStart, NavigationCancel} from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorPageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/error-page/error-page.component.ts